export var valuesNewUserStateDto = ["Removed", "SetToInactive"];
/*

*/ 
//# sourceMappingURL=NewUserStateDto.js.map